import React, { useEffect, useState } from "react";
import SVG from "../../../../components/SVG/SVG";
import { Failure } from "../../../../components/ToastNotification/Failure";
import { Success } from "../../../../components/ToastNotification/Success";
import { AdminServices, createNewUser } from "../../../../services/dashboard/adminDashboard.services";
import { LargeScreenModificationPanel } from "./LargeScreenModificationPanel";
import { updateProfile } from "../../../../services/base-api";
import { CreateSubAdmin } from "./CreateSubAdmin";
import { Button, Stack } from "knack-ui";
import { useGetAuthToken } from "../../../../features/Auth/authMutations";
import { useUser } from "../../../../features/User/userQueries";
import { isDev } from "../../../../lib/utils";

export const SubAdmin = ({ onEditUser, companies, onCreateUser, setUserDrawerOpen, setSelectedUser }) => {
  const { data: user } = useUser();
  const { mutateAsync } = useGetAuthToken();
  async function onLoginToAccount(e, user) {
    e.stopPropagation();
    await mutateAsync({ user });
  }
  const [subAdmins, setSubAdmins] = useState([]);
  const [filteredAdmins, setFilteredAdmins] = useState([]);
  const [newUser, setNewUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    kind: "SUBADMIN",
    organization: ""
  });
  const [itemsSelected, setItemsSelected] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    fetchAdmins();
  }, [setSubAdmins, setFilteredAdmins]);

  function fetchAdmins() {
    AdminServices.getUsersByType("Subadmin")
      .then((res) => {
        if (res.data.status) {
          const { data } = res.data;
          setSubAdmins(data);
          setFilteredAdmins(data);
        }
      })
      .catch((e) => {
        console.log(e);
        Failure("Oops Something went wrong. Unable to fetch sub admin List");
      });
  }

  function onSaveUser() {
    if (newUser.first_name !== "" && newUser.last_name !== "" && newUser.email !== "" && newUser.password !== "") {
      // NEW USER
      if (!newUser._id) {
        createNewUser(newUser)
          .then((res) => {
            if (res.data.status) {
              Success("User Created Successfully!");
              setIsOpen(false);
              fetchAdmins();
              setNewUser({
                first_name: "",
                last_name: "",
                email: "",
                password: "",
                kind: "SUBADMIN"
              });
            } else {
              Failure(res.data.message);
              console.log(res.data.message);
            }
          })
          .catch((e) => {
            console.log(e);
            Failure("Oops Something went wrong. Please try again");
          });
      }
      // UPDATE USER
      else {
        updateUserName(newUser);
      }
    }
  }

  function updateUserName(pending_user) {
    let userProfile = { ...pending_user, user: pending_user._id };
    updateProfile(userProfile)
      .then((res) => {
        if (res.data.status) {
          Success("User updated Successfully!");
          fetchAdmins();
          setNewUser({
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            kind: "SUBADMIN"
          });
          setIsOpen(false);
        } else {
          console.log(res);
          Failure("Something went wrong, Please try again");
        }
      })
      .catch((e) => {
        console.log(e);
        Failure("Something went wrong, Please try again");
      });
  }

  function onClose() {
    setItemsSelected([]);
  }

  function onSearchContacts(value) {
    if (value !== "") {
      const _filtered = subAdmins.filter((c) => c.email.includes(value.toLowerCase()));
      setFilteredAdmins(_filtered);
    } else {
      setFilteredAdmins(subAdmins);
    }
  }

  function onEditUser(user) {
    setIsOpen(true);
    user.kind = user.role.toUpperCase();
    setNewUser(user);
  }

  function onDeleteUser(userId) {
    AdminServices.deleteUser(userId)
      .then((res) => {
        Success("User deleted");
        fetchAdmins();
      })
      .catch((e) => {
        console.log(e);
        Failure("Oops Something went wrong. Please try again");
      });
  }

  return (
    <div className="bg-white rounded-lg shadow">
      {isOpen && (
        <CreateSubAdmin
          newUser={newUser}
          setNewUser={setNewUser}
          isOpen={isOpen}
          setOpen={setIsOpen}
          companies={companies}
          onCreateUser={() => onSaveUser()}
        />
      )}
      <div className="bg-white rounded-lg shadow">
        <div className="flex items-center justify-between flex-row  bg-white p-2 my-4">
          <div className="w-full">
            {" "}
            <input
              placeholder="Search Sub Admin..."
              type="text"
              className="rounded-lg w-full max-w-sm"
              onChange={(e) => onSearchContacts(e.target.value)}
            />
          </div>
          {/* Create Company */}
          <div
            className="text-white px-4 py-2 rounded-md cursor-pointer text-sm flex flex-row items-center"
            onClick={() => {
              setNewUser({ email: "", password: "", kind: "SUBADMIN" });
              setIsOpen(true);
            }}
            style={{ background: "rgb(31, 64, 230)" }}
          >
            <div className="hidden sm:inline-block -ml-2 mr-2">
              <SVG name="Add" />
            </div>
            <span className="whitespace-nowrap"> Create Sub Admin</span>
          </div>
        </div>

        {/* table header */}
        <div className="grid grid-cols-3 p-4 font-bold text-sm xl:text-base border-b">
          <div>Name</div>
          <div>Email</div>
        </div>

        {filteredAdmins.map((c, i) => (
          <div
            key={i}
            className={`grid grid-cols-3 p-4text-sm xl:text-base p-4 hover:bg-blue-50 cursor-pointer font-medium ${itemsSelected.find(({ _id }) => _id === c._id) === undefined ? "" : "bg-blue-50"
              }`}
            onClick={() => {
              if (itemsSelected.find(({ _id }) => _id === c._id)) {
                const selected = [...itemsSelected].filter((f) => f._id !== c._id);
                setItemsSelected(selected);
              } else {
                const selected = itemsSelected.length > 0 ? [...itemsSelected] : [];
                selected.push(c);
                setItemsSelected(selected);
              }
            }}
          >
            <div className="text-sm">
              <span
                className={`h-3 w-3 rounded mr-2 mt-0 inline-block border ${itemsSelected.find(({ _id }) => _id === c._id) === undefined ? "" : "bg-skin-fill"
                  }`}
              />
              {c?.first_name} {c?.last_name}
            </div>
            <div className="text-sm">{c?.email}</div>
          </div>
        ))}
      </div>

      <LargeScreenModificationPanel
        List={itemsSelected}
        resetList={() => setItemsSelected([])}
        components={<div></div>}
        onDelete={user.account_type === "Admin" ? onDeleteUser : null}
        onEdit={onEditUser}
      />
    </div>
  );
};
